import PropertyItem, { IPropertyItemType } from './properyItem';
import { IProperyItem } from 'redhotpie-shared-lib/interfaces/IProperyItem';

export interface IApiEditProfileLookup {
  BodyHair?: IPropertyItemType[];
  BodyType?: IPropertyItemType[];
  Drinking?: IPropertyItemType[];
  EndowmentLength?: IPropertyItemType[];
  EndowmentThickness?: IPropertyItemType[];
  EyeColour?: IPropertyItemType[];
  FetishInterest?: IPropertyItemType[];
  GeneralInterest?: IPropertyItemType[];
  HairColour?: IPropertyItemType[];
  HairLength?: IPropertyItemType[];
  Height?: IPropertyItemType[];
  Intention?: IPropertyItemType[];
  IntimatePiercing?: IPropertyItemType[];
  MaritalStatus?: IPropertyItemType[];
  MemberTypePlural?: IPropertyItemType[];
  MyLooks?: IPropertyItemType[];
  ParticipationLevel?: IPropertyItemType[];
  Personality?: IPropertyItemType[];
  PubicHair?: IPropertyItemType[];
  Race?: IPropertyItemType[];
  SafeSex?: IPropertyItemType[];
  Sexual?: IPropertyItemType[];
  SexualInterestCouple?: IPropertyItemType[];
  SexualInterestSingle?: IPropertyItemType[];
  SexualPersonality?: IPropertyItemType[];
  Smoking?: IPropertyItemType[];
  SeekingRelationshipStatus?: IPropertyItemType[];
  CupSize?: IPropertyItemType[];
}

export default class EditProfileLookup {
  bodyHair: IProperyItem[] | null;
  bodyType: IProperyItem[] | null;
  drinking: IProperyItem[] | null;
  endowmentLength: IProperyItem[] | null;
  endowmentThickness: IProperyItem[] | null;
  eyeColour: IProperyItem[] | null;
  fetishInterest: IProperyItem[] | null;
  generalInterest: IProperyItem[] | null;
  hairColour: IProperyItem[] | null;
  hairLength: IProperyItem[] | null;
  height: IProperyItem[] | null;
  intention: IProperyItem[] | null;
  dealBreaker: IProperyItem[] | null;
  intimatePiercing: IProperyItem[] | null;
  maritalStatus: IProperyItem[] | null;
  memberTypePlural: IProperyItem[] | null;
  myLooks: IProperyItem[] | null;
  participation: IProperyItem[] | null;
  personality: IProperyItem[] | null;
  pubicHair: IProperyItem[] | null;
  race: IProperyItem[] | null;
  safeSex: IProperyItem[] | null;
  sexualOrientation: IProperyItem[] | null;
  sexualInterestCouple: IProperyItem[] | null;
  sexualInterestSingle: IProperyItem[] | null;
  sexualPersonality: IProperyItem[] | null;
  smoking: IProperyItem[] | null;
  seekingRelationshipStatus: IProperyItem[] | null;
  cupSize: IProperyItem[] | null;

  constructor() {
    this.bodyHair = null;
    this.bodyType = null;
    this.drinking = null;
    this.endowmentLength = null;
    this.endowmentThickness = null;
    this.eyeColour = null;
    this.fetishInterest = null;
    this.generalInterest = null;
    this.hairColour = null;
    this.hairLength = null;
    this.height = null;
    this.intention = null;
    this.dealBreaker = null;
    this.intimatePiercing = null;
    this.maritalStatus = null;
    this.memberTypePlural = null;
    this.myLooks = null;
    this.participation = null;
    this.personality = null;
    this.pubicHair = null;
    this.race = null;
    this.safeSex = null;
    this.sexualOrientation = null;
    this.sexualInterestCouple = null;
    this.sexualInterestSingle = null;
    this.sexualPersonality = null;
    this.smoking = null;
    this.seekingRelationshipStatus = null;
    this.cupSize = null;
  }

  static mappingObject(_obj: IApiEditProfileLookup): EditProfileLookup {
    const obj = new EditProfileLookup();

    obj.bodyHair = _obj.BodyHair ? PropertyItem.mappingObjects(_obj.BodyHair) : null;
    obj.bodyType = _obj.BodyType ? PropertyItem.mappingObjects(_obj.BodyType) : null;
    obj.drinking = _obj.Drinking ? PropertyItem.mappingObjects(_obj.Drinking) : null;
    obj.endowmentLength = _obj.EndowmentLength ? PropertyItem.mappingObjects(_obj.EndowmentLength) : null;
    obj.endowmentThickness = _obj.EndowmentThickness ? PropertyItem.mappingObjects(_obj.EndowmentThickness) : null;
    obj.eyeColour = _obj.EyeColour ? PropertyItem.mappingObjects(_obj.EyeColour) : null;
    obj.fetishInterest = _obj.FetishInterest ? PropertyItem.mappingObjects(_obj.FetishInterest) : null;
    obj.generalInterest = _obj.GeneralInterest ? PropertyItem.mappingObjects(_obj.GeneralInterest) : null;
    obj.hairColour = _obj.HairColour ? PropertyItem.mappingObjects(_obj.HairColour) : null;
    obj.hairLength = _obj.HairLength ? PropertyItem.mappingObjects(_obj.HairLength) : null;
    obj.height = _obj.Height ? PropertyItem.mappingObjects(_obj.Height) : null;
    obj.intention = _obj.Intention ? PropertyItem.mappingObjects(_obj.Intention) : null;
    obj.dealBreaker = _obj.Intention ? PropertyItem.mappingObjects(_obj.Intention) : null;
    obj.intimatePiercing = _obj.IntimatePiercing ? PropertyItem.mappingObjects(_obj.IntimatePiercing) : null;
    obj.maritalStatus = _obj.MaritalStatus ? PropertyItem.mappingObjects(_obj.MaritalStatus) : null;
    obj.memberTypePlural = _obj.MemberTypePlural ? PropertyItem.mappingObjects(_obj.MemberTypePlural) : null;
    obj.myLooks = _obj.MyLooks ? PropertyItem.mappingObjects(_obj.MyLooks) : null;
    obj.participation = _obj.ParticipationLevel ? PropertyItem.mappingObjects(_obj.ParticipationLevel) : null;
    obj.personality = _obj.Personality ? PropertyItem.mappingObjects(_obj.Personality) : null;
    obj.pubicHair = _obj.PubicHair ? PropertyItem.mappingObjects(_obj.PubicHair) : null;
    obj.race = _obj.Race ? PropertyItem.mappingObjects(_obj.Race) : null;
    obj.safeSex = _obj.SafeSex ? PropertyItem.mappingObjects(_obj.SafeSex) : null;
    obj.sexualOrientation = _obj.Sexual ? PropertyItem.mappingObjects(_obj.Sexual) : null;
    obj.sexualInterestCouple = _obj.SexualInterestCouple ? PropertyItem.mappingObjects(_obj.SexualInterestCouple) : null;
    obj.sexualInterestSingle = _obj.SexualInterestSingle ? PropertyItem.mappingObjects(_obj.SexualInterestSingle) : null;
    obj.sexualPersonality = _obj.SexualPersonality ? PropertyItem.mappingObjects(_obj.SexualPersonality) : null;
    obj.smoking = _obj.Smoking ? PropertyItem.mappingObjects(_obj.Smoking) : null;
    obj.seekingRelationshipStatus = _obj.SeekingRelationshipStatus ? PropertyItem.mappingObjects(_obj.SeekingRelationshipStatus) : null;
    obj.cupSize = _obj.CupSize ? PropertyItem.mappingObjects(_obj.CupSize) : null;

    return obj;
  }
}
